@use "ui/styles/colorsOld";

.wrapper {
  &.expandable {
    :global {
      .options {
        width: fit-content;
        min-width: 100%;
      }
    }
  }

  &.leftAligned {
    :global {
      .options {
        right: unset;
        left: 0;
      }
    }
  }

  &.rightAligned {
    :global {
      .options {
        left: unset;
        right: 0;
        max-width: 336px;
      }
    }
  }
}
